import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {catchError, map} from 'rxjs/operators';
import {NotificationBase} from '../../notifications/interfaces/notification-base.interface';
import {endpoints} from '../common/api-endpoints';
import {DataService} from './data.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends DataService<NotificationBase> {
  constructor(httpClient: HttpClient) {
    super(endpoints.notification, httpClient);
  }

  setSeen(notificationId) {
    return this.http.put(this.url + `${notificationId}/seen`, {});
  }
  getByDomain(domain): Observable<NotificationBase[]> {
    return this.http.get(this.url + 'domain/' + domain).pipe(
      map((response: NotificationBase[]) => response),
      catchError(this.handleError)
    );
  }
}
